import * as React from "react";
import TextField from "@mui/material/TextField";
import Error from "../error-msg";

export default function CsInput({
  id,
  type = "text",
  getValue,
  label,
  placeholder,
  defaultVal,
  error = false,
  errorMsg,
  onBlur,
  autoFocus = false,
  disabled = false,
  inputProps = {},
  val,
  cusStyle
}) {
  // const [value, setValue] = React.useState(val);

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <TextField
        autoFocus={autoFocus}
        fullWidth
        type={type}
        label={label}
        id={id}
        value={val}
        defaultValue={defaultVal}
        placeholder={placeholder}
        error={error}
        onChange={(e) => {
          // setValue(e.target.value)
          getValue(e.target.value);
        }}
        onBlur={onBlur}
        disabled={disabled}
        InputProps={inputProps}
        sx={cusStyle}
      />
      {error && <Error errorMsg={errorMsg} />}
    </div>
  );
}
